<template>
  <div class="mini-kasko-order__modal" @click.self="$emit('close')">
    <div class="mini-kasko-order__modal-dialog" role="dialog" aria-modal="true" aria-labelledby="mini-kasko-payment-title">
      <button
        type="button"
        class="mini-kasko-order__modal-close"
        aria-label="Закрити"
        @click="$emit('close')"
      >
        &times;
      </button>
      <h2 id="mini-kasko-payment-title" class="mini-kasko-order__modal-title">Рахунок сформовано</h2>
      <p class="mini-kasko-order__modal-subtitle">Відскануйте QR-код або перейдіть за посиланням для оплати.</p>
      <div v-if="paymentQrCode" class="mini-kasko-order__payment-qr">
        <img :src="paymentQrCode" alt="QR-код для оплати">
      </div>
      <div class="mini-kasko-order__payment-link-field">
        <input :value="paymentLink" readonly type="text">
        <button
          type="button"
          class="mini-kasko-order__icon-action"
          @click="$emit('copy')"
          aria-label="Скопіювати посилання на оплату"
          title="Скопіювати посилання"
        >
          Копіювати
        </button>
      </div>
      <button
        type="button"
        class="mini-kasko-order__action mini-kasko-order__action--primary"
        @click="$emit('go-to-link')"
      >
        Перейти до оплати
      </button>
      <small
        class="mini-kasko-order__otp-send-message"
        :class="{ 'mini-kasko-order__otp-send-message--hidden': !paymentLinkMessage }"
      >
        {{ paymentLinkMessage }}
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MiniKaskoPaymentModal',
  props: {
    paymentLink: String,
    paymentQrCode: String,
    paymentLinkMessage: String,
  },
  emits: ['close', 'copy', 'go-to-link'],
};
</script>

<style lang="scss" scoped>
.mini-kasko-order {
  &__modal {
    position: fixed;
    z-index: 10000;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background-color: rgba(15, 23, 42, 0.55);
  }

  &__modal-dialog {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    width: 100%;
    max-width: 460px;
    padding: 24px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22);
  }

  &__modal-close {
    position: absolute;
    top: 10px;
    right: 12px;
    width: 32px;
    height: 32px;
    border: 0;
    background: transparent;
    color: #475569;
    font-size: 28px;
    line-height: 28px;
    cursor: pointer;
  }

  &__modal-title {
    margin: 0;
    padding-right: 32px;
    color: #0f172a;
    font-size: 22px;
    line-height: 28px;
    font-weight: 600;
  }

  &__modal-subtitle {
    margin: 0;
    color: #475569;
    font-size: 14px;
    line-height: 20px;
  }

  &__payment-qr {
    display: flex;
    justify-content: center;

    img {
      width: 168px;
      height: 168px;
      object-fit: contain;
      border: 1px solid #e2e8f0;
      border-radius: 6px;
      background-color: #fff;
    }
  }

  &__payment-link-field {
    display: flex;
    gap: 8px;

    input {
      min-width: 0;
      flex: 1;
      height: 38px;
      padding: 8px 10px;
      border: 1px solid #cbd5e1;
      border-radius: 6px;
      background-color: #fff;
      color: #0f172a;
      font-size: 13px;
      line-height: 18px;
    }
  }

  &__icon-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    padding: 0 12px;
    border: 1px solid #94a3b8;
    border-radius: 6px;
    background-color: #fff;
    color: #0f172a;
    font-size: 13px;
    line-height: 18px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;

    &:hover {
      background-color: #f1f5f9;
    }
  }

  &__action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 190px;
    min-height: 48px;
    padding: 0 18px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;

    &:disabled {
      opacity: 0.6;
      cursor: default;
    }

    &--primary {
      background: #fb923c;
      color: #fff;
      border: 0;
    }
  }

  &__otp-send-message {
    display: block;
    min-height: 18px;
    color: #15803d;
    font-size: 13px;
    line-height: 18px;

    &--hidden {
      visibility: hidden;
    }
  }
}
</style>
